import { render, staticRenderFns } from "./ArticlePage.vue?vue&type=template&id=54f5477d&scoped=true&"
import script from "./ArticlePage.vue?vue&type=script&lang=js&"
export * from "./ArticlePage.vue?vue&type=script&lang=js&"
import style0 from "./ArticlePage.vue?vue&type=style&index=0&id=54f5477d&scoped=true&lang=css&"
import style1 from "./ArticlePage.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54f5477d",
  null
  
)

export default component.exports